import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ThemeServiceService {
  setTheme(theme: 'light' | 'dark') {
    const linkId = 'app-theme';
    let linkEl = document.getElementById(linkId) as HTMLLinkElement;
    if (!linkEl) {
      linkEl = document.createElement('link');
      linkEl.id = linkId;
      linkEl.rel = 'stylesheet';
      document.head.appendChild(linkEl);
    }
    linkEl.href = `assets/themes/${theme}-theme.css?v=${Date.now()}`; // avoid cache
  }
}
